import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/views/layout/MainLayout.vue'
import UserLayout from '@/views/layout/UserLayout.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: '', name: 'Home', component: () => import('@/views/Home.vue') },
      { path: 'engine/:code', name: 'EngineDetail', component: () => import('@/views/EngineDetail.vue') },
      { path: 'pricing', name: 'Pricing', component: () => import('@/views/Pricing.vue') },
      { path: 'cases', name: 'Cases', component: () => import('@/views/Cases.vue') },
      { path: 'knowledge', name: 'Knowledge', component: () => import('@/views/Knowledge.vue') },
      { path: 'knowledge/:id', name: 'KnowledgeDetail', component: () => import('@/views/KnowledgeDetail.vue') },
      { path: 'channel', name: 'Channel', component: () => import('@/views/ChannelPartner.vue') },
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    meta: { requireAuth: true },
    children: [
      { path: '', redirect: '/user/dashboard' },
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/Dashboard.vue') },
      { path: 'admin', name: 'AdminDashboard', component: () => import('@/views/AdminDashboard.vue'), meta: { roles: ['admin'] } },
      { path: 'new-review', name: 'NewReview', component: () => import('@/views/NewReview.vue'), meta: { roles: ['admin'] } },
      { path: 'tasks', name: 'MyTasks', component: () => import('@/views/MyTasks.vue'), meta: { roles: ['admin'] } },
      { path: 'report/:taskId', name: 'ReportView', component: () => import('@/views/ReportView.vue') },
      { path: 'compare/:taskId', name: 'CompareView', component: () => import('@/views/CompareView.vue') },
      { path: 'membership', name: 'Membership', component: () => import('@/views/Membership.vue'), meta: { roles: ['admin', 'creator'] } },
      { path: 'profile', name: 'Profile', component: () => import('@/views/Profile.vue') },
      { path: 'new-video', name: 'NewVideo', component: () => import('@/views/NewVideo.vue'), meta: { roles: ['admin', 'creator'] } },
      { path: 'anime-studio', name: 'AnimeStudio', component: () => import('@/views/AnimeStudio.vue'), meta: { roles: ['admin', 'creator'] } },
      { path: 'videos', name: 'MyVideos', component: () => import('@/views/MyVideos.vue'), meta: { roles: ['admin', 'creator'] } },
      { path: 'prompt-library', name: 'PromptLibrary', component: () => import('@/views/PromptLibrary.vue') },
      { path: 'publish-center', name: 'PublishCenter', component: () => import('@/views/PublishCenter.vue') },
      { path: 'schedule-center', name: 'ScheduleCenter', component: () => import('@/views/ScheduleCenter.vue') },
      { path: 'video-config', name: 'VideoConfig', component: () => import('@/views/VideoConfig.vue'), meta: { roles: ['admin'] } },
    ]
  },
  { path: '/login', name: 'Login', component: () => import('@/views/Login.vue') },
  { path: '/register', name: 'Register', component: () => import('@/views/Register.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const role = localStorage.getItem('role') || 'creator'
  if (to.meta.requireAuth && !token) return next('/login')
  if (to.path === '/user/dashboard') {
    return next(role === 'admin' ? '/user/admin' : '/user/new-video')
  }
  if (to.meta.roles && !to.meta.roles.includes(role)) {
    return next(role === 'admin' ? '/user/admin' : '/user/new-video')
  }
  next()
})

export default router
